<!--<c-header class="mb-4 d-print-none" position="sticky">-->
<ng-container>
  <c-container [fluid]="true" class="border-bottom px-3">
    <button
      [cSidebarToggle]="sidebarId()"
      cHeaderToggler
      class="btn"
      toggle="visible"
      style="margin-inline-start: -14px;"
      aria-label="Toggle sidebar navigation"
      [class.badge]="!!badge()"
    >
      <svg cIcon name="cilMenu" size="lg"></svg>
    </button>

    <c-header-nav class="d-md-flex ms-auto ">
      <!-- <c-breadcrumb-router /> -->
      <app-breadcrumb></app-breadcrumb>
    </c-header-nav>


    <!-- <c-header-nav class="ms-0 d-none d-md-flex"> -->
    <c-header-nav class="d-md-flex ms-0">
      @if (headerAction) {
        <ng-container *ngComponentOutlet="headerAction" />
      }
      @if (communityEnabled()) {
        <ng-container *ngTemplateOutlet="notificationDropdown" />
      }
      <ng-container *ngTemplateOutlet="languageDropdown" />
      <span class="separator"></span>
      <ng-container *ngTemplateOutlet="userDropdown" />
    </c-header-nav>

    <!--aside toggler-->
    <!-- <button
      cHeaderToggler
      cSidebarToggle="aside1"
      style="margin-inline-end: -12px"
      toggle="visible"
    >
      <svg cIcon name="cilApplicationsSettings" size="lg"></svg>
    </button> -->
  </c-container>
  <!-- <c-container [fluid]="true" class="px-4">
    <c-breadcrumb-router />
  </c-container> -->
</ng-container>
<!--</c-header>-->

<ng-template #notificationDropdown>
  <c-dropdown [popperOptions]="{ placement: 'bottom-end' }" variant="nav-item" alignment="end">
    <button [caret]="false" cDropdownToggle class="py-0 position-relative" aria-label="Open notifications"
            (click)="loadRecentNotifications()">
      <svg cIcon name="cilBell" size="lg"></svg>
      @if (unreadNotifications() > 0) {
        <span class="badge bg-danger rounded-pill default-header__bell-badge">
          {{ unreadNotifications() > 99 ? '99+' : unreadNotifications() }}
        </span>
      }
    </button>
    <ul cDropdownMenu class="pt-0 default-header__notifications-menu">
      <li class="d-flex align-items-center justify-content-between px-3 py-2 border-bottom">
        <span class="fw-semibold">{{ 'community.notifications.title' | translate }}</span>
        @if (unreadNotifications() > 0) {
          <button type="button" class="btn btn-link btn-sm p-0" (click)="markAllNotificationsRead()">
            {{ 'community.notifications.mark_all_read' | translate }}
          </button>
        }
      </li>
      @if (notificationsLoading()) {
        <li class="text-center py-3"><div class="spinner-border spinner-border-sm" role="status"></div></li>
      } @else if (recentNotifications().length === 0) {
        <li class="px-3 py-3 text-muted small">{{ 'community.notifications.empty' | translate }}</li>
      } @else {
        @for (n of recentNotifications(); track n.id) {
          <li>
            <a cDropdownItem class="default-header__notification-item" [class.default-header__notification-item--unread]="!n.read"
               role="button" (click)="openNotification(n)">
              <div class="fw-semibold small">{{ n.title }}</div>
              <div class="text-muted small text-truncate">{{ n.body }}</div>
              <div class="text-muted" style="font-size: 0.75rem;">{{ n.created_at | date:'short' }}</div>
            </a>
          </li>
        }
      }
      <li class="border-top d-flex align-items-center justify-content-between">
        <a cDropdownItem class="small" [routerLink]="notificationsLink()">
          {{ 'community.notifications.see_all' | translate }}
        </a>
        <a cDropdownItem class="small w-auto flex-shrink-0" [routerLink]="notificationSettingsLink()"
           [title]="'community.settings.title' | translate" [attr.aria-label]="'community.settings.title' | translate">⚙</a>
      </li>
    </ul>
  </c-dropdown>
</ng-template>

<ng-template #userDropdown>
  <c-dropdown [popperOptions]="{ placement: 'bottom-start' }" variant="nav-item">
    <button [caret]="false" cDropdownToggle class="py-0" aria-label="Open user menu">
      <svg cIcon name="cilUser" size="lg"></svg>
      <!-- <span style="font-weight: bold; font-size: 1.2rem;">.</span> -->
      <!--
      <c-avatar
        shape="rounded-1"
        size="md"
        src="./assets/images/avatars/8.jpg"
        status="success"
        textColor="primary"
        alt="User avatar"
      />
      -->
    </button>
    <ul cDropdownMenu class="pt-0 w-auto">
      <li>
        <span cDropdownItem style="font-weight: bold; font-size: 1.2rem;">{{ this.getUsername() }}</span>
      </li>
      <li>
        <a cDropdownItem [routerLink]="['/', getLanguage(), 'profile']">
          <svg cIcon class="me-2" name="cilUser"></svg>
            {{ 'profile.title' | translate }}
        </a>
      </li>
      @if (!platform.is('hybrid') || !environment.production) {
        <li>
          <a cDropdownItem (click)="logout()">
            <svg cIcon class="me-2" name="cilAccountLogout"></svg>
            {{ 'logout' | translate }}
          </a>
        </li>
      }
    </ul>
  </c-dropdown>
</ng-template>

<ng-template #languageDropdown>
  <c-dropdown alignment="end" variant="nav-item">
    <button *ngIf="selectedLanguage() && availableLanguages.length > 1" [caret]="false" cDropdownToggle aria-label="Open language picker">
        <svg cIcon name="cisGlobe" size="lg"></svg>
        <!-- <span
          class="flag flag-sm"
          [ngClass]="'flag-' + (flags[selectedLanguage] || selectedLanguage.toUpperCase())"
        ></span> -->
        <span class="ms-1 align-middle">{{ languageLabels[selectedLanguage()] }}</span>
    </button>
    <div cDropdownMenu>
      <button
        *ngFor="let lang of availableLanguages"
        (click)="changeLanguage(lang)"
        [active]="selectedLanguage() === lang"
        cDropdownItem
        class="d-flex align-items-center"
      >
        <!-- <span
          class="flag flag-sm me-2"
          [ngClass]="'flag-' + (flags[lang] || lang.toUpperCase())"
        ></span> -->
        <span class="align-middle">{{ languageLabels[lang] }}</span>
      </button>
    </div>
  </c-dropdown>
</ng-template>

<ng-template #themeDropdown>
  <c-dropdown alignment="end" variant="nav-item">
    <button [caret]="false" cDropdownToggle aria-label="Open theme picker">
      <svg cIcon [name]="icons()" size="lg"></svg>
    </button>
    <div cDropdownMenu>
      @for (mode of colorModes; track mode.name) {
        <button
          (click)="colorMode.set(mode.name)"
          [active]="colorMode()===mode.name"
          cDropdownItem
          class="d-flex align-items-center"
        >
          <svg cIcon class="me-2" [name]="mode.icon" size="lg"></svg>
          {{ mode.text }}
        </button>
      }
    </div>
  </c-dropdown>
</ng-template>

